module.exports = {"pathContext":{"name":"StockTransferRequestStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"COMPLETED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DRAFT"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"REQUESTED"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-stock-transfer-request-status.json
// module id = 1316
// module chunks = 159635755708896